import { NotificationsContainer } from 'src/containers';

export const Notifications = () => <NotificationsContainer />;
